<a (click)="showPicture()" *ngIf="!pictureShowed">
    <i class="fa fa-eye"></i>
    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.events.picture-upload.show'}]"></span>
</a>

<img class="local-load-event-picture" *ngIf="pictureShowed" [src]="pictureUrl">

<a (click)="downloadPicture()" *ngIf="pictureShowed">
    <i class="fa fa-download"></i>
    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.events.picture-upload.download'}]"></span>
</a>
